import Cookies from 'universal-cookie';
import axios from 'axios';

const cookies = new Cookies();
export default axios.create({
    baseURL: process.env.REACT_APP_url_api,
    headers: { Authorization: `Bearer ${cookies.get('loggedToken')}` },
});
